import { getStoreState } from 'config/store'
import { getMessageAttribute } from 'modules/message/utils'
import { compose, filter, find, head, pathOr } from 'ramda'
import { WidgetAlignment } from 'shared/constants/frames'
import { Embed, EmbedCampaign, EmbedTheme, TeamUser } from 'types/embed'

export const getEmbedThemeProperty = <P extends keyof EmbedTheme>(embed: Embed, property: P, defaultValue: EmbedTheme[P] = null) =>
  pathOr<EmbedTheme[P]>(defaultValue, ['configuration', 'theme', property], embed)

export const getCampaignIdFromInteractionId = (interactionId: number): number | null => {
  const campaigns = pathOr(null, ['embed', 'configuration', 'campaigns'], getStoreState())
  if (campaigns) {
    const hasInteractionId = campaign => getMessageAttribute(campaign, 'interactionId') === interactionId
    const matchedCampaign = head(filter(hasInteractionId, campaigns))
    if (matchedCampaign) {
      return matchedCampaign.id
    }
  }
  return null
}

export const getCampaignPropertyById = <P extends keyof EmbedCampaign> (campaignId: number, property: string) : EmbedCampaign[P] => {
  const campaign = getCampaignFromEmbedById(campaignId)

  if (!campaign) {
    return null
  }

  return pathOr(null, [property], campaign)
}

export const getCampaignFromEmbedById = (campaignId: number): EmbedCampaign => {
  const campaigns = pathOr<EmbedCampaign[]>([], ['embed', 'configuration', 'campaigns'], getStoreState())
  return campaigns.filter(campaign => campaign.id === campaignId)[0]
}

export const getWidgetAlignment = () => pathOr(WidgetAlignment.RIGHT, ['embed', 'configuration', 'theme', 'alignment'], getStoreState())

export const getOrgId = () : number => pathOr(0, ['embed', 'orgId'], getStoreState())

const findBotId = compose<any, TeamUser[], TeamUser, number>(
  pathOr<number>(undefined, ['id']),
  find<TeamUser>(teamUser => teamUser.bot),
  pathOr<TeamUser[]>([], ['embed', 'configuration', 'team'])
)

export const getBotSenderId = (): number => findBotId(getStoreState())

export const getEmbedLocale = () : string => pathOr('en', ['embed', 'configuration', 'locale'], getStoreState())

export const getUseWidgetLocaleForGDPR = () : boolean => pathOr(false, ['embed', 'configuration', 'dataProtection', 'targetBasedOnWidgetLocale'], getStoreState())
